exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.definition[data-v-0583ca3e] {\n  border: solid 1px #ccc;\n  border-radius: .5rem;\n  padding: 1.5rem 1rem;\n  cursor: pointer;\n}\n.definition.active[data-v-0583ca3e] {\n  background-color: #1a8ffc;\n  color: white;\n  border: solid 1px #0479e7;\n  cursor: default;\n}\n.definition[data-v-0583ca3e]:not(.active):hover {\n  background-color: #f1f1f1;\n}\n.relations[data-v-0583ca3e] {\n  padding: 1rem 1.5rem;\n}\n.relations .item[data-v-0583ca3e] {\n  margin-bottom: .5rem;\n}\n.email_recipient_tabs[data-v-0583ca3e] {\n  width: 100%\n}\n", ""]);

// exports
